import {
  SkeletonLine,
  SkeletonRectangle,
  Box,
  SkeletonGroup,
} from '@wix/design-system';
import React from 'react';
import { useSiteContext } from '@wix/app-market-core';

export function SubCategoryHeaderSkeleton() {
  const { horizontalNav } = useSiteContext();

  if (horizontalNav) {
    /* matches the compact header: back button inline with a medium title */
    return (
      <SkeletonGroup skin="light">
        <Box dataHook="skeleton-title">
          <SkeletonRectangle width="240px" height="24px" />
        </Box>
      </SkeletonGroup>
    );
  }

  return (
    <SkeletonGroup skin="light">
      <Box dataHook="skeleton-header" marginTop="30px">
        <Box marginTop="4px" marginLeft="4px">
          <SkeletonLine width="350px" />
        </Box>
      </Box>
      <Box dataHook="skeleton-title" marginTop="18px">
        <SkeletonRectangle width="300px" height="36px" />
      </Box>
    </SkeletonGroup>
  );
}
